import { SetStateAction, Dispatch as DispatchReact, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { TableCheckItems } from 'CorePackage/MainModule/types/TableCheckItems';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { Table } from 'CorePackage/TableModule/components/Table';
import { handleSortChange } from 'CorePackage/MainModule/common/handleSortChange';
import { getSortOrder } from 'CorePackage/MainModule/common/getSortOrder';
import { getSortOrderByPeriod } from 'CorePackage/MainModule/common/getSortOrderByPeriod';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './DecisionsTable.module.scss';
import { IDecisionListItem } from '../interfaces/IDecisionListItem';
import { getDecisionListData, getDecisionListTotalCount } from '../selectors/decisionListSelectors';
import { decisionListGetDataNextPage, decisionListSetOrder } from '../actions/decisionListActions';

interface ITemplatesTableProps {
  columns: ITableColumn<IDecisionListItem>[];
  itemsCheck: TableCheckItems;
  setItemsCheck: DispatchReact<SetStateAction<TableCheckItems>>;
  setTableColumns: DispatchReact<SetStateAction<ITableColumn<IDecisionListItem>[]>>;
}

interface IDecisionsTableStoreProps {
  decisionListData: IDecisionListItem[];
  decisionsCount: number;
}

const DecisionsTableWithoutStore = ({
  columns,
  itemsCheck,
  setItemsCheck,
  setTableColumns,
  decisionListData,
  decisionsCount,
}: ITemplatesTableProps & IDecisionsTableStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const handleSortChangeClick = useCallback(
    (id: ITableColumn<IDecisionListItem>['id']) => {
      const newColumnsData = handleSortChange(columns, id);

      setTableColumns(newColumnsData);
      let order = getSortOrder(newColumnsData, getSortOrderByPeriod);

      order = order
        .replace('kindResultDecisionCode', 'firstKindResultDecisionCode')
        .replace('decisionDate', 'firstDecisionDate');

      dispatch(decisionListSetOrder(order));
    },
    [columns, dispatch, setTableColumns],
  );

  const handleLoadClick = useCallback(() => {
    dispatch(decisionListGetDataNextPage());
  }, [dispatch]);

  return (
    <>
      <Table<IDecisionListItem>
        columns={columns}
        itemsCheck={itemsCheck}
        data={decisionListData}
        setItemsCheck={setItemsCheck}
        onSortChange={handleSortChangeClick}
        columnStyles={styles}
        checkedNames={['решение', 'решения', 'решений']}
        handleLoadClick={handleLoadClick}
        totalCount={decisionsCount}
      />
    </>
  );
};

const mapStateToProps = (state: IRootState): IDecisionsTableStoreProps => ({
  decisionListData: getDecisionListData(state),
  decisionsCount: getDecisionListTotalCount(state),
});

export const DecisionsTable = connect(mapStateToProps)(DecisionsTableWithoutStore);
